import Countdown from 'react-countdown'

export default Countdown
